import {Box, FormControl, TextField} from "@mui/material";
import {Controller} from "react-hook-form";
import {useLingui} from "@lingui/react";
import {msg} from "@lingui/macro";

const FormAddReport = ({control, isMobile}) => {
    const {_} = useLingui()
    return (
        <Box display="flex" flexDirection="column" gap={1} sx={{width: '100%'}}>
            <FormControl fullWidth>
                <Controller
                    name="title"
                    control={control}
                    defaultValue=""
                    rules={{required: _(msg`Title is required`)}}
                    render={({field, fieldState}) => (
                        <TextField
                            {...field}
                            label={_(msg`Title`)}
                            fullWidth
                            required
                            margin={isMobile ? 'dense' : 'normal'}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}
                />
            </FormControl>
            <FormControl fullWidth>
                <Controller
                    name="description"
                    control={control}

                    render={({field, fieldState}) => (
                        <TextField
                            {...field}
                            label={_(msg`Description`)}
                            fullWidth
                            multiline
                            rows={7}
                            margin={isMobile ? 'dense' : 'normal'}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}
                />
            </FormControl>
        </Box>
    )
}
export default FormAddReport;